import WondeBaseSerializer from './base';

export default class School extends WondeBaseSerializer {}
